import {downloadFile} from '@domain/file-download'
import {spawnErrorToast} from '@hm/fundamental'
import {useMutation} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {downloadHierarchySubmissions} from '../../common/backend/locationStats'
import {FEATURE_NAMESPACE} from '../../consts'

export const useHierarchyDownload = () => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return useMutation({
    mutationFn: () => downloadHierarchySubmissions(),
    onSuccess: (blob: Blob) => {
      downloadFile(blob, 'plant-hierarchy_submissions.xlsx')
    },
    onError: () => {
      spawnErrorToast(t('errors.excelDownloadFailed'))
    }
  })
}
